import React from 'react';

export default ({ statusMessage }) => <div className="addtl-order-details">{ statusMessage }</div>
